<template>
  <v-container>
    <!--app-view-toolbar-->
    <app-view-toolbar title="Registrera chaufförskonto" :showBackButton="true" :isEdit="false"></app-view-toolbar>
    <template v-if="viewDataIsLoaded">
      <v-form ref="formSignup">
        <v-row>
          <v-col>
            <!--user-form-fields-->
            <app-user-form-fields :data="viewData.userData"></app-user-form-fields>
            <!--driver-form-fields-->
            <app-driver-form-fields :data="viewData.driverData"></app-driver-form-fields>
            <!--approve-gdpr-policy-->
            <app-approve-gdpr-policy :data="approveGdprPolicyData"></app-approve-gdpr-policy>
          </v-col>
        </v-row>
      </v-form>
      <!--app-form-bottom-->
      <app-form-bottom
        :postWasInvalid="postWasInvalid"
        :errorOutput="errorOutput"
        @onSubmit="doSubmit"
        submitText="Registrera"
        @onErrorOk="postWasInvalid = false"
      ></app-form-bottom>
    </template>
    <!--bank-id-->
    <app-bank-id
      headline="Verifiera med BankID"
      mode="auth"
      :dialog="showBankIdDialog"
      @close="showBankIdDialog = false"
      @complete="onBankIdComplete"
      :returnUrl="bankIdReturnUrl"
    ></app-bank-id>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>
<script>
import axios from 'axios'
import BankId from '../components/BankId'
import SnackBar from '../components/SnackBar'
import UserFormFields from '../components/UserFormFields'
import DriverFormFields from '../components/DriverFormFields'
import ViewToolbar from '../components/ViewToolbar'
import ApproveGdprPolicy from '../components/ApproveGdprPolicy'
import FormBottom from '../components/FormBottom'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { snackBarBus } from '../main'

export default {
  name: 'SignupDriver',
  components: {
    'app-bank-id': BankId,
    'app-snack-bar': SnackBar,
    'app-form-bottom': FormBottom,
    'app-user-form-fields': UserFormFields,
    'app-driver-form-fields': DriverFormFields,
    'app-view-toolbar': ViewToolbar,
    'app-approve-gdpr-policy': ApproveGdprPolicy
  },
  mixins: [generalMixin, urlMixin], 
  data() {
    return {
      devMode: false,
      viewData: {
        userData: {
          firstname: '',
          lastname: '',
          email: '',
          mobile: ''
        },
        driverData: {
          address: '',
          address2: '',
          zip: '',
          city: '',
//          bankClearingNumber: '',
//          bankAccountNumber: '',
          citizenShip: '',
          management: '',
          organizationNumber: ''
        }
      },
      approveGdprPolicyData: {
        approveGdpr: false,
      },
      viewDataIsLoaded: false,
      postWasInvalid: false,
      errorOutput: '',
      bankIdReturnUrl: '',
      showBankIdDialog: false,
      bankIdToken: null
    }
  },
  computed: {
  },
  methods: {
    doSubmit(doCommitSave = false) {
      const allowSubmitOfInvalidForm = false
      let okToSubmit = true;
      if (!allowSubmitOfInvalidForm) {
        const formIsValid = this.$refs.formSignup.validate()
//        console.log('formIsValid', formIsValid)
        okToSubmit = formIsValid
      }
      if (okToSubmit) {
        //post data to API
        let postData = {
          doCommitSave: doCommitSave,
          driverData: this.viewData.driverData,
          userData: this.viewData.userData,
          approveGdpr: this.approveGdprPolicyData.approveGdpr
        }
        //set config for axios request with Authorization header (only required if doCommitSave)
        let config = {
          headers: {
            'Authorization': (doCommitSave) ? this.bankIdToken : ''
          }
        }
        let url = this.url_composeApiUrl('/driver/signup')
        axios.post(url, postData, config)
          .then(response => {
//            console.log('axios', response)
            if (response.data.success) {
              //success
              if (doCommitSave) {
                //call action onAuth in store
                let dataToDispatch = {
                  access_token: response.data.returnData.access_token,
                  loggedInData: response.data.returnData.loggedInData
                }
                this.$store.dispatch('onAuth', dataToDispatch).then(() => {
                  //go to dashboard
                  this.$router.replace({ name: 'driver-dashboard'})
                })
              } else {
                //this was just a 'pre-bankId test save' - show bankID
                this.showBankIdDialog = true;
              }
            } else {
              //non success
              this.errorOutput = this.generalParseErrorArray(response.data.returnData.error_ar)
              this.postWasInvalid = true
            }
          })
          .catch(error => {
            snackBarBus.$emit('message', error.toString())
            this.postWasInvalid = true
          })
      }
    },
    onBankIdComplete(token) {
//      console.log("DriverSignup - onBankIdComplete", token)
      this.showBankIdDialog = false
      this.bankIdToken = token
      //submit and commit
      this.doSubmit(true)
    }
  },
  created() {
    this.bankIdReturnUrl = this.getAbsUrl('/home')
    //get view data
    let url = this.url_composeApiUrl('/driver/edit/0')
    axios.get(url)
      .then(response => {
//        console.log(url + ' response', response)
        if (response.data.success) {
          //success
          this.viewData = response.data.returnData.viewData
          this.viewDataIsLoaded = true
        } else if (this.onNonSuccessApiCall(response.data.returnData)) {
          snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
        }
      })
      .catch(error => {
        snackBarBus.$emit('message', error.toString())
      })
  }
}
</script>
